// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"bb04c9ca","643":"bb04c9ca","851":"f0bdad8d","872":"bb04c9ca"}[chunkId] + ".chunk.css";
};